import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/site";
import { useScrolledPast } from "@/hooks/useLandingNav";

/** Scroll distance after which the floating WhatsApp button fades in. */
const SHOW_AFTER_SCROLL_PX = 320;

export const FloatingWhatsApp = () => {
  const visible = useScrolledPast(SHOW_AFTER_SCROLL_PX);

  return (
    <a
      href={COMPANY.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with Moruya on WhatsApp"
      className={`fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#148a8f] text-white shadow-[var(--shadow-lg)] transition-[opacity,transform,background-color] duration-200 hover:bg-[#0f6e73] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1aa3a8] focus-visible:ring-offset-2 ${
        visible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
    </a>
  );
};
